var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { get, sample, sampleSize, compact, uniq, isNull } from "lodash";
import { Grid } from "react-bootstrap";
import styled from "styled-components";
import withAuth from "@irati/auth/helpers/auth/withAuth";
import id from "@irati/utils/id";
import ShowPopUpAction from "@irati/store/actions/ShowSuccessPopUp";
import vitally from "@irati-web/platform/src/utils/vitally";
import padding from "@irati/ui/src/global/padding";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import tracking from "@irati-tracking/perks/perks";
import authentication from "@irati/auth";
import { DEFAULT_RADIUS_METERS } from "@irati/geolocation/src/constants/proximity";
import { hasValidValues } from "@irati/geolocation/src/helpers/latLng";
import HomePageQueryComponent from "@irati/deals/apollo/query/HomePage";
import LANE_TYPES from "@irati/deals/constants/laneTypes";
import { PERKSGO } from "@irati-web/app/src/routeConfig";
import isBucketLoaded from "@irati/utils/lang/helpers/isBucketLoaded";
import PerksGOBanner from "@irati-web/perksgo/src/components/PerksGOBanner";
import Loading from "@irati/ui/src/Loading";
import { geolocationTracking } from "@irati-tracking/geolocation";
import { getCompanyBenefitsLogo, getBenefitsSchemeHeader } from "@irati/deals/helpers/deals/appearance";
import { getDealForHomepageBanner } from "@irati/deals/helpers/deals/homepageBanner";
import dealSettingsService from "@irati/deals/services/perksSettings";
import { getPrivateUserMetadata } from "@irati/user-metadata/services/UserMetadata";
import reorderHomepageLanes from "@irati/deals/helpers/deals/reorderHomepageLanes";
import DealsFavourites from "@irati/deals/apollo/query/DealFavourites";
import favouritesService from "@irati/deals/services/favourites";
import HomePageBanner from "../../components/HomePageBanner";
import FeedSliderGraph, { ITEM_SIZE_SMALL } from "../../components/FeedSlider";
import SectionHeader from "../../components/SectionHeader";
import SpendSectionHeader from "../../components/SectionHeader/SpendSectionHeader";
import EarnSectionHeader from "../../components/SectionHeader/EarnSectionHeader";
import TopCategories from "../../components/TopCategories";
import PerksNearMeCTA from "../../components/PerksNearMeCTA";
import CustomisationBanner from "../../components/CustomisationBanner";
import CustomCategories from "../../components/CustomCategories";
import { StyledHr } from "./styled/HomePage";
var StyledTopCategories = styled(TopCategories)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-bottom: calc(", " - 10px);\n"], ["\n  padding-bottom: calc(", " - 10px);\n"])), padding.base);
var CUSTOMISATION_OPTIONS_TO_DISPLAY = 3;
var HomePage = /** @class */ (function (_super) {
    __extends(HomePage, _super);
    function HomePage(props) {
        var _this = _super.call(this, props) || this;
        _this.getSettings = function () {
            var userTenant = _this.props.auth.userTenant;
            var uuid = userTenant.uuid;
            dealSettingsService.get(uuid).then(function (dealSettings) {
                var companyBenefitsTopOfHomepage = get(dealSettings, "companyBenefits.topOfHomepage", false);
                _this.setState({ companyBenefitsTopOfHomepage: companyBenefitsTopOfHomepage });
            });
        };
        _this.getUserMetadata = function () {
            var user = _this.props.auth.user;
            var uuid = user.uuid;
            return getPrivateUserMetadata(uuid, { forceRefetch: true }).then(function (metadata) {
                _this.setState({ metadata: metadata, hasFetchedMetadata: true });
            });
        };
        _this.handleSearchAllByLocationCTAClick = function () {
            geolocationTracking.clickPerksHomepagePerksNearMeCTA(_this.props.userLocation.city);
        };
        _this.setPerksNearMeLaneTracking = function () {
            var _a = _this.props.userLocation, _b = _a.latLng, lat = _b.lat, lng = _b.lng, city = _a.city;
            if (hasValidValues(lat, lng) && !_this.state.perksNearMeLaneTrackingSent) {
                _this.setState({ perksNearMeLaneTrackingSent: true });
                geolocationTracking.viewPerksHomepagePerksNearMeLane(city);
            }
        };
        _this.getAdditionalProps = function (type, tag) {
            var additionalProps = {};
            if (type === LANE_TYPES.SPEND) {
                additionalProps.SectionHeader = SpendSectionHeader;
                additionalProps.tag = tag;
            }
            else if (type === LANE_TYPES.EARN) {
                additionalProps.SectionHeader = EarnSectionHeader;
                additionalProps.tag = tag;
                additionalProps.showDealLocation = true;
            }
            return additionalProps;
        };
        _this.renderLane = function (type, tag, deals, headerText, bodyText, idNamespace, index) {
            // @todo: Remove feature flag check once live
            var branding = _this.props.branding;
            if ((type === LANE_TYPES.SPEND && !authentication.apps("wallet.users")) ||
                (type === LANE_TYPES.EARN && (!authentication.apps("wallet.users") || !authentication.apps("perks.perksGo")))) {
                return null;
            }
            var Component;
            var key;
            if (type === LANE_TYPES.NEAR_ME) {
                Component = (React.createElement(PerksNearMeCTA, { id: id("perks-near-me-cta", idNamespace), userLocation: _this.props.userLocation, headerText: headerText, bodyText: bodyText }));
            }
            else if (deals.length > 0) {
                var companyBenefitsLogo = getCompanyBenefitsLogo(branding);
                var additionalProps = _this.getAdditionalProps(type, tag);
                key = tag ? tag.uuid : index;
                Component = (React.createElement(FeedSliderGraph, __assign({ data: deals, sectionHeaderText: _this.getHeaderName(type, tag, headerText), sectionBodyText: bodyText, id: id(type, idNamespace), logo: type === LANE_TYPES.COMPANY ? companyBenefitsLogo : null, itemSize: type === LANE_TYPES.FAVOURITE ? ITEM_SIZE_SMALL : null }, additionalProps)));
            }
            if (Component) {
                return (React.createElement(Fragment, { key: key || index },
                    React.createElement(StyledHr, null),
                    Component));
            }
            return null;
        };
        _this.orderHomepageLanes = function (homepageLanes, idNamespace) {
            return reorderHomepageLanes(homepageLanes.results, _this.state.companyBenefitsTopOfHomepage).map(function (_a, index) {
                var type = _a.type, tag = _a.tag, deals = _a.deals, headerText = _a.headerText, bodyText = _a.bodyText;
                return _this.renderLane(type, tag, deals, headerText, bodyText, idNamespace, index);
            });
        };
        _this.getBannerSuggestions = function (homepageDealCategories) {
            var randomNames = compact(homepageDealCategories)
                .filter(function (_a) {
                var active = _a.active, type = _a.type;
                return active === true && isNull(type);
            })
                .map(function (_a) {
                var _b;
                var tags = _a.tags;
                return (_b = sample(tags)) === null || _b === void 0 ? void 0 : _b.name;
            });
            return sampleSize(compact(uniq(randomNames)), CUSTOMISATION_OPTIONS_TO_DISPLAY);
        };
        var intl = props.intl;
        _this.state = {
            perksNearMeLaneTrackingSent: false,
            /*
              @todo: Remove this once we have got rid of react-intl
              react-intl has a bug when using the LangLoader on a bucket that isn't loaded yet -
              it rips out all components and causes them to be re-mounted causing the constructor to be called twice.
              This approach checks that the PerksGO bucket is loaded first as the FeedSlider component has logic
              that would throw an error when a component is unmounted immediately after mount
            */
            isPerksGoBucketLoaded: !authentication.apps("platform.fidel") || isBucketLoaded(intl, PERKSGO),
            companyBenefitsTopOfHomepage: false,
            metadata: null,
            hasFetchedMetadata: false
        };
        return _this;
    }
    HomePage.prototype.componentDidMount = function () {
        // force an update to favourites on load of page
        var user = this.props.auth.user;
        favouritesService.list({ userId: user.uuid }, { fetchPolicy: "network-only" });
        this.getSettings();
        this.getUserMetadata();
        this.setPerksNearMeLaneTracking();
        tracking.viewHome();
        vitally.showSurvey(this.props.formatMessage);
    };
    HomePage.prototype.componentWillUnmount = function () {
        this.props.showPopUp({ show: false });
    };
    HomePage.prototype.componentDidUpdate = function () {
        this.setPerksNearMeLaneTracking();
    };
    HomePage.prototype.getHeaderName = function (type, tag, customHeaderName) {
        var _a = this.props, formatMessage = _a.formatMessage, userTenant = _a.auth.userTenant;
        var benefitSchemeHeader = getBenefitsSchemeHeader();
        switch (type) {
            case LANE_TYPES.FAVOURITE:
                return formatMessage({ id: "perks.containers.homepage.favourites" });
            case LANE_TYPES.COMPANY:
                return benefitSchemeHeader || formatMessage({ id: "perks.containers.homepage.benefits" }, { name: userTenant.public_name });
            case LANE_TYPES.NEW:
                return formatMessage({ id: "perks.containers.homepage.newPerks" });
            case LANE_TYPES.TRENDING:
                return formatMessage({ id: "perks.containers.homepage.trending" });
            case LANE_TYPES.SPEND:
                return formatMessage({ id: "perks.containers.homepage.spend" });
            case LANE_TYPES.EARN:
                return customHeaderName;
            case LANE_TYPES.TAG:
                return tag ? tag.name : null;
            default:
                return null;
        }
    };
    HomePage.prototype.render = function () {
        var _this = this;
        var _a = this.props, userLocation = _a.userLocation, formatMessage = _a.formatMessage, auth = _a.auth;
        var user = auth.user;
        var idNamespace = id("homepage", this.props, { force: true });
        /**  containers should force to init the idNamespace */
        var _b = this.state, isPerksGoBucketLoaded = _b.isPerksGoBucketLoaded, metadata = _b.metadata, hasFetchedMetadata = _b.hasFetchedMetadata;
        var _c = userLocation.latLng, lat = _c.lat, lng = _c.lng, error = userLocation.error, load = userLocation.load;
        var isLocationAvailable = hasValidValues(lat, lng);
        if (load && !error && !isLocationAvailable) {
            return React.createElement(Loading, { load: load });
        }
        var variables = {};
        if (isLocationAvailable) {
            variables.lat = lat;
            variables.lng = lng;
            variables.radius = DEFAULT_RADIUS_METERS;
        }
        return (React.createElement(HomePageQueryComponent, { variables: variables }, function (_a) {
            var _b = _a.data, homepageBanner = _b.homepageBanner, homepageBirthdayBanner = _b.homepageBirthdayBanner, homepageDealCategories = _b.homepageDealCategories, homepageLanes = _b.homepageLanes;
            return (React.createElement(React.Fragment, null,
                React.createElement(HomePageBanner, { id: idNamespace, deal: getDealForHomepageBanner(homepageBanner, homepageBirthdayBanner) }),
                React.createElement(Grid, null,
                    authentication.apps("perks.perksGo") && React.createElement(PerksGOBanner, { id: id("perksgo-banner", idNamespace) }),
                    (user && hasFetchedMetadata) && React.createElement(CustomisationBanner, { user: user, metadata: metadata, suggestions: _this.getBannerSuggestions(homepageDealCategories === null || homepageDealCategories === void 0 ? void 0 : homepageDealCategories.results) }),
                    metadata && React.createElement(CustomCategories, { idNamespace: id("custom-categories", idNamespace), metadata: metadata }),
                    React.createElement(SectionHeader, { id: id("categories", idNamespace), linkLabel: formatMessage({ id: "perks.containers.homepage.topCategories.label" }), linkTo: "/categories", onClick: tracking.clickBrowseByCategory },
                        React.createElement(FormattedMessage, { id: "perks.containers.homepage.topCategories.title" })),
                    homepageDealCategories && React.createElement(StyledTopCategories, { id: idNamespace, categories: homepageDealCategories.results }),
                    isPerksGoBucketLoaded && (React.createElement(DealsFavourites, { variables: { userId: user.uuid } }, function (_a) {
                        var data = _a.data;
                        return (React.createElement(FeedSliderGraph, { id: id("favourites", idNamespace), data: data === null || data === void 0 ? void 0 : data.dealFavourites, sectionHeader: _this.getHeaderName(LANE_TYPES.FAVOURITE), itemSize: ITEM_SIZE_SMALL, isFavouriteDeal: true }));
                    })),
                    homepageLanes && _this.orderHomepageLanes(homepageLanes, idNamespace))));
        }));
    };
    return HomePage;
}(PureComponent));
var mapStateToProps = function (_a) {
    var mq = _a.mq, geoLocation = _a.geoLocation;
    return ({ mq: mq, userLocation: geoLocation.userLocation });
};
/**
 * @param dispatch
 */
var mapDispatchToProps = function (dispatch) { return ({
    showPopUp: function (options) { return dispatch(ShowPopUpAction(options)); }
}); };
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withAuth(HomePage)));
var templateObject_1;
